import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "orangehrm-background-container" }

import OnboardingTable from '../components/OnboardingTable.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Onboarding',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_oxd_input_field = _resolveComponent("oxd-input-field")!
  const _component_oxd_grid_item = _resolveComponent("oxd-grid-item")!
  const _component_date_input = _resolveComponent("date-input")!
  const _component_oxd_grid = _resolveComponent("oxd-grid")!
  const _component_oxd_form_row = _resolveComponent("oxd-form-row")!
  const _component_oxd_divider = _resolveComponent("oxd-divider")!
  const _component_required_text = _resolveComponent("required-text")!
  const _component_oxd_button = _resolveComponent("oxd-button")!
  const _component_oxd_form_actions = _resolveComponent("oxd-form-actions")!
  const _component_oxd_form = _resolveComponent("oxd-form")!
  const _component_oxd_table_filter = _resolveComponent("oxd-table-filter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(OnboardingTable, null, {
      default: _withCtx(({filters, onReset}) => [
        _createVNode(_component_oxd_table_filter, { "filter-title": "Onboarding list" }, {
          default: _withCtx(() => [
            _createVNode(_component_oxd_form, { onReset: onReset }, {
              default: _withCtx(() => [
                _createVNode(_component_oxd_form_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_oxd_grid, {
                      cols: 4,
                      class: "orangehrm-full-width-grid"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_oxd_grid_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_oxd_input_field, {
                              modelValue: filters.owners,
                              "onUpdate:modelValue": ($event: any) => ((filters.owners) = $event),
                              label: "Owners",
                              value: "Select",
                              type: "multiselect",
                              options: []
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_oxd_grid_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_oxd_input_field, {
                              modelValue: filters.assignes,
                              "onUpdate:modelValue": ($event: any) => ((filters.assignes) = $event),
                              label: "Assigned to",
                              value: "Select",
                              type: "multiselect",
                              options: []
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_oxd_grid_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_date_input, {
                              modelValue: filters.dueDate,
                              "onUpdate:modelValue": ($event: any) => ((filters.dueDate) = $event),
                              label: "Due Date"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_oxd_divider),
                _createVNode(_component_oxd_form_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_required_text),
                    _createVNode(_component_oxd_button, {
                      "display-type": "ghost",
                      label: _ctx.$t('general.reset'),
                      type: "reset"
                    }, null, 8, ["label"]),
                    _createVNode(_component_oxd_button, {
                      class: "orangehrm-left-space",
                      "display-type": "secondary",
                      label: _ctx.$t('general.search'),
                      type: "submit"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onReset"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ]))
}
}

})